import { projects, getProjectsForSection } from "@/data/projects";
import Image from "next/image";
import { motion } from "framer-motion";
import { useEffect, useState } from "react";

// Utiliser la même logique que le carousel pour la cohérence
const uniqueProjects = getProjectsForSection("carousel")
  .filter(
    (project, index, self) =>
      index === self.findIndex((p) => p.id === project.id),
  )
  .slice(0, 3);

export const Phone = () => {
  const [currentProjectIndex, setCurrentProjectIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentProjectIndex(
        (prevIndex) => (prevIndex + 1) % uniqueProjects.length,
      );
    }, 6000);

    return () => clearInterval(interval);
  }, []);

  const project = uniqueProjects[currentProjectIndex];

  if (!project || !project.mockupPhoneImage) {
    return null;
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: 40, scale: 0.95 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      transition={{ duration: 0.8, ease: "easeOut", delay: 2.0 }}
      className="relative mx-auto mt-6 block h-[700px] w-[350px] rounded-[2.5rem] border-[14px] border-gray-800 bg-gray-800 dark:border-gray-800 sm:hidden"
    >
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.6, ease: "easeOut", delay: 0.2 }}
        className="h-[672px] w-[322px] overflow-hidden rounded-[2rem] bg-white dark:bg-gray-800"
      >
        <Image
          src={project.mockupPhoneImage}
          alt={project.name}
          width={322}
          height={672}
          className="h-[682px] w-[332px] object-cover"
        />
      </motion.div>
    </motion.div>
  );
};
